module.exports = __webpack_public_path__ + "static/img/logo-login@2x.adfaf50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-login@2x.svg
// module id = I7do
// module chunks = 125